import { axios, API, SendRequest } from '@/imports-files/pages/clients/communication/email-details';

export class EmailDetailsService extends SendRequest 
{

  async getEmailDetailData(params, comms_id) 
  {
    const url = API.client.communication.GET_EMIAL_DATA.replace('$comms_id', comms_id);
     try {
            const result = await axios.get( url,
              {
                  params: params,
                  headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());

            return result;
          } 
          catch (error)
          {
            return error;
          }

  }

  async markAsImportantAndUnimportant(params) 
  {
    const url = API.client.communication.MARK_AS_IMPORTANT;
     try {
            const result = await axios.put( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());

            return result;
          } 
          catch (error)
          {
            return error;
          }

  }

   async deleteEmail(params) 
  {
    const url = API.client.communication.THREAD_DELETE;
     try {
            const result = await axios.delete( url,
               {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());

            return result;
          } 
          catch (error)
          {
            return error;
          }

  }

}